import CurrenciesSelect from './container';

export default CurrenciesSelect;
